module.exports = __webpack_public_path__ + "img/login_gb_uno.9f257a25.png";